export default __webpack_public_path__ + "locales/nl/About.json?hash=76bc3ec5a9b5868049265d339b789bea";